"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Object2D_1 = require("engine/ui/Object2D");
/**
 * If we're repeating the same text a lot we can improve performance by having a single text instance and re-rendering it at different locations
 *
 * **The original text instance is modified an should not be rendered on its own after using in a TextClone**
 */
var TextClone = /** @class */ (function (_super) {
    __extends(TextClone, _super);
    function TextClone(text, color) {
        if (color === void 0) { color = [0, 0, 0, 1]; }
        var _this = _super.call(this) || this;
        _this.text = text;
        _this.additiveBlending = 0.0;
        _this.glyphLayoutChanged = function () {
            _this.worldTransformNeedsUpdate = true;
            _this.text.removeEventListener('glyphLayoutChanged', _this.glyphLayoutChanged);
        };
        _this.color = color;
        _this.transparent = true;
        _this.blendMode = text.blendMode;
        return _this;
    }
    Object.defineProperty(TextClone.prototype, "_w", {
        get: function () { return this.text.w; },
        set: function (v) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextClone.prototype, "_h", {
        get: function () { return this.text.h; },
        set: function (v) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextClone.prototype, "render", {
        get: function () { return this.text.render; },
        set: function (v) { },
        enumerable: true,
        configurable: true
    });
    TextClone.prototype.onAdded = function () {
        if (this.text.w === 0) {
            this.text.addEventListener('glyphLayoutChanged', this.glyphLayoutChanged);
        }
    };
    TextClone.prototype.onRemoved = function () {
        this.text.removeEventListener('glyphLayoutChanged', this.glyphLayoutChanged);
    };
    TextClone.prototype.allocateGPUResources = function (device) {
        var textInternal = this.text;
        if (textInternal.gpuResourcesNeedAllocate) {
            textInternal.allocateGPUResources(device);
            textInternal.gpuResourcesNeedAllocate = false;
        }
        this.gpuProgram = textInternal.gpuProgram;
        this.gpuVertexState = textInternal.gpuVertexState;
    };
    TextClone.prototype.releaseGPUResources = function () { };
    TextClone.prototype.draw = function (context) {
        var textInternal = this.text;
        // override with local transform and color
        textInternal.worldTransformMat4 = this.worldTransformMat4;
        this.text.color = this.color;
        this.text.additiveBlending = this.additiveBlending;
        this.text.opacity = this.opacity;
        this.text.draw(context);
    };
    return TextClone;
}(Object2D_1.default));
exports.TextClone = TextClone;
exports.default = TextClone;
